import { useEffect } from 'react';

import { getWebSdkDashboardBreadcrumbsRoutes } from 'src/apps/web-sdks/helpers/WebSdkHelper';
import { usePermissions } from 'src/common/hooks/usePermissions';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

export const useSetWebSdkBreadcrumbs = (runId: string, testName: string, runTime: string): void => {
	const { updateBreadcrumbRoutes, setBreadcrumbRoutes } = useBreadcrumbStore();
	const isPlatformEnabledForWebSdks = usePermissions(ProductType.WEB_SDK);

	useEffect(() => {
		const webSdkBreadcrumbs = getWebSdkDashboardBreadcrumbsRoutes(runId, testName, runTime);
		updateBreadcrumbRoutes(isPlatformEnabledForWebSdks ? webSdkBreadcrumbs : []);

		return () => {
			setBreadcrumbRoutes([]);
		};
	}, [
		runId,
		testName,
		runTime,
		isPlatformEnabledForWebSdks,
		updateBreadcrumbRoutes,
		setBreadcrumbRoutes
	]);
};
